import firebase from "config/firebase";

export const createCityRequest = (obj) => async (dispatch) => {
  try {
    const docRef = await firebase
      .firestore()
      .collection("requested_locations")
      .add(obj);
    const notificationData = {
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      type: "city",
      notifyID: docRef.id,
      status: false,
    };

    await firebase
      .firestore()
      .collection("admin_notifiaction")
      .add(notificationData);
  } catch (error) {
    console.error("Error creating city request:", error.message);
  }
};

export const getCityRequests =
  (lastDocument, onSuccess) => async (dispatch) => {
    let querya = firebase.firestore().collection("requested_locations");
    if (lastDocument) {
      querya = querya.startAfter(lastDocument);
    }
    querya = querya.limit(5);
    const unsubscribe = querya.onSnapshot((querySnapshot) => {
      let temp_data = [];
      querySnapshot.forEach((doc) => {
        temp_data.push({
          id: doc.id,
          ...doc.data(),
        });
      });
      dispatch({
        type: lastDocument ? "GET_CITY_REQUEST_MORE" : "GET_CITY_REQUEST",
        payload: {
          data: temp_data,
          lastDocument: querySnapshot.docs[temp_data.length - 1] || null,
          hasMoreDocument: temp_data.length >= 5,
        },
      });
      if (onSuccess) onSuccess();
    });
    return unsubscribe;
  };

export const updateCityRequest = (id, data) => {
  return async (dispatch) => {
    await firebase
      .firestore()
      .collection("requested_locations")
      .doc(id)
      .update({
        supported_by: data,
        support: data.length,
      });
  };
};
